import { NavLink } from "react-router-dom";
import { LayoutDashboard, Package, Truck, Sliders, AlertTriangle, Boxes, Mail, Send } from "lucide-react";

const TABS = [
  { to: "/admin", label: "Dashboard", icon: LayoutDashboard, end: true },
  { to: "/admin/orders", label: "Orders", icon: Package },
  { to: "/admin/exceptions", label: "Human Review", icon: AlertTriangle },
  { to: "/admin/waitlist", label: "Waitlist", icon: Mail },
  { to: "/admin/emails", label: "Emails", icon: Send },
  { to: "/admin/suppliers", label: "Suppliers", icon: Truck },
  { to: "/admin/supplier-products", label: "Supplier Mapping", icon: Boxes },
  { to: "/admin/pricing", label: "Pricing Rules", icon: Sliders },
];

export default function AdminNav() {
  return (
    <div className="border-b border-zinc-800 mb-6 -mx-1 overflow-x-auto">
      <div className="flex items-center gap-1 min-w-max px-1">
        {TABS.map((t) => (
          <NavLink key={t.to} to={t.to} end={t.end}
            data-testid={`adminnav-${t.label.toLowerCase().replace(/\s+/g, '-')}`}
            className={({ isActive }) =>
              `flex items-center gap-2 px-4 py-3 font-mono text-xs tracking-widest uppercase whitespace-nowrap border-b-2 ${
                isActive ? "border-[#FF5C00] text-[#FF5C00]" : "border-transparent text-zinc-400 hover:text-white"
              }`
            }>
            <t.icon className="w-4 h-4" />
            {t.label}
          </NavLink>
        ))}
      </div>
    </div>
  );
}

export function AdminHeader({ title, subtitle }) {
  return (
    <div className="mb-6">
      <div className="font-mono text-xs tracking-widest text-[#FF5C00] mb-1">// ADMIN</div>
      <h1 className="font-display font-black text-3xl md:text-4xl">{title}</h1>
      {subtitle && <p className="text-sm text-zinc-500 mt-1">{subtitle}</p>}
    </div>
  );
}
